<template>
  <v-layout fluid grid-list-md>
    <MyList v-if="myList && myList.length" :programs="myList" :catalogo="false"></MyList>
    <v-flex xs12 v-if="!(myList && myList.length)">
      <TitlePlanetHorror title="Lista vacía" :catalogo="catalogo"></TitlePlanetHorror>
    </v-flex>
  </v-layout>
</template>
<script>
import MyList from '@/components/MyList'
import TitlePlanetHorror from '@/components/TitlePlanetHorror'
import { mapGetters } from 'vuex'
export default {
  components: { MyList, TitlePlanetHorror },
  props: {
    catalogo: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['myList'])
  }
}
</script>
